<template>
  <div>
    <Frontendlayout>
      <section class="hero_in contacts">
        <div class="wrapper">
          <div class="container">
            <h1 class="fadeInUp"><span></span>Journey Planner</h1>
          </div>
        </div>
      </section>
      <!--/hero_in-->

      <div class="bg_color_1">
        <div class="container margin_80_55">
          <div class="row justify-content-between">
            <div class="col-lg-3">
              <Sidebar />
            </div>
            <div class="col-lg-8">
              <!-- <h5 class="text-center">Journey Planner</h5> -->
              <form class method="post">
                <div class="row custom-search-input-2">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>From Date</label>
                      <date-picker
                        v-model="from_date"
                        :datepickerconfig="datepickerconfig"
                      ></date-picker>
                      <!-- <input
                        class="form-control"
                        v-model="from_date"
                        type="datetime-local"
                        placeholder="Date.."
                      /> -->
                      <!-- <i class="icon_calendar"></i> -->
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>To Date</label>
                      <date-picker
                        v-model="to_date"
                        :config="datepickerconfig"
                      ></date-picker>
                      <!-- <input
                        class="form-control"
                        v-model="to_date"
                        type="datetime-local"
                        placeholder="Date.."
                      /> -->
                      <!-- <i class="icon_calendar"></i> -->
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Travelling From</label>
                      <input
                        class="form-control"
                        v-model="travelling_from"
                        type="text"
                        placeholder="Travelling From.."
                      />
                      <i class="icon-home"></i>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Travelling To</label>
                      <input
                        class="form-control"
                        v-model="travelling_to"
                        type="text"
                        placeholder="Travelling To.."
                      />
                      <i class="icon-home"></i>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <label>Journey Type</label>

                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        v-model="journey_type"
                        v-bind:value="'single'"
                        style="height: unset"
                      />
                      <label class="form-check-label" for="flexRadioDefault1">
                        Single Journey
                      </label>
                    </div>

                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        v-model="journey_type"
                        v-bind:value="'return'"
                        style="height: unset"
                      />
                      <label class="form-check-label" for="flexRadioDefault1">
                        Return Journey
                      </label>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Would You Like To Name of This Journey</label>
                      <input
                        class="form-control"
                        v-model="journey_name"
                        type="text"
                        placeholder="Name of Journey.."
                      />
                      <i class="icon-home"></i>
                    </div>
                  </div>
                </div>

                <alert v-if="msg" :msg="msg" :classAlert="classAlert"></alert>

                <div id="pass-info" class="clearfix"></div>
                <button
                  type="submit"
                  class="btn_1 rounded add_top_30"
                  @click="journey('destination')"
                >
                  Plan My Journey
                </button>
                <button
                  type="submit"
                  class="btn_1 rounded add_top_30"
                  @click="journey('finish')"
                >
                  Finish Journey
                </button>
              </form>
            </div>
          </div>
          <!-- /row -->
        </div>
        <!-- /container -->
      </div>
      <!-- /bg_color_1 -->
    </Frontendlayout>
  </div>
</template>
<script>
// import axios from 'axios'
import Alert from "@/cmps/Alert";
import API from "@/services/index";
import Sidebar from "@/layouts/Sidebar.vue";
import Frontendlayout from "@/layouts/Frontendlayout.vue";
export default {
  data() {
    return {
      from_date: "",
      to_date: "",
      travelling_from: "",
      travelling_to: "",
      journey_type: "",
      journey_name: "",
      msg: null,
      classAlert: null,
      id: null,
    };
  },
  beforeMount() {
    this.checkToken();
  },
  methods: {
    checkToken() {
      const token = localStorage.getItem("token");
      // alert(token);
      if (token == null) {
        this.$router.push("/signin");
      }
    },

    journey(redirect) {
      const form = new FormData();
      form.append("from_date", this.from_date);
      form.append("to_date", this.to_date);
      form.append("travelling_from", this.travelling_from);
      form.append("travelling_to", this.travelling_to);
      form.append("journey_type", this.journey_type);
      form.append("journey_name", this.journey_name);
      const token = "Bearer " + localStorage.getItem("token");

      API.post("/userjourney/create", form, {
        headers: { Authorization: token },
      })
        .then((res) => {
          console.log(res.data.messages);

          if (res.data.status == 200) {
            this.msg =
              "Your journey is created. Please add destinations to avail offers";
            this.classAlert = "success";
            this.from_date = "";
            this.to_date = "";
            this.travelling_from = "";
            this.travelling_to = "";
            this.journey_type = "";
            this.journey_name = "";
            const id = window.btoa(res.data.data.user_journey_id);
            if (redirect == "finish") {
              this.$router.push("/my-journey");
            } else this.$router.push("/add-destination-list/" + id);
          } else {
            this.msg = res.data.messages;
            this.classAlert = "danger";
          }
        })
        .catch((err) => {
          this.msg = err.response.data.messages.error;
          this.classAlert = "danger";
        });
      //axios
    },
  },
  components: {
    Alert,
    Frontendlayout,
    Sidebar,
  },
};
</script>

<style  scoped>
.custom-search-input-2 input {
  border: 1px solid #d2d8dd !important;
}
.custom-search-input-2 {
  padding: 20px !important;
}
.form-group {
  margin-bottom: 30px;
}
.custom-search-input-2 i {
  top: 35px;
  height: unset !important;
  line-height: unset;
}
.custom-search-input-2 input {
  height: 35px;
}
figure img {
  width: 439px;
  height: 310px;
  margin-top: 17px;
}
.form-check-label {
  position: relative;
  bottom: 5px !important;
}
</style>